module.exports = __webpack_public_path__ + "img/login-icon.59af4c32.png";